import { format } from "date-fns";
import React, { useEffect } from "react";
import styled, { ThemedStyledProps, css } from "styled-components";
import Icon from "./Icon";
import { useTranslation } from "react-i18next";

const DaySwitchBase = styled.div`
  background-color: #fff;
  border-radius: 10px;
  padding: 10px 20px;
  font-family: Roboto, sans-serif;
  display: flex;
  justify-content: space-between;
  user-select: none;
`;

const DaySwitchArrow = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 10px;
  cursor: pointer;
`;

interface DaySwitchProps {
  value?: number;
  onChange?: (value: number) => void;
  max?: number;
  min?: number;
  date: Date;
}

const DaySwitch = ({ value, onChange, max, min = 0, date }: DaySwitchProps) => {
  const [numValue, setNumValue] = React.useState(value || 0);
  const { t } = useTranslation();

  useEffect(() => {
    onChange && onChange(numValue);
  }, [numValue]);

  return (
    <DaySwitchBase>
      <div style={{ minWidth: 44 }}>
        {numValue > min && (
          <DaySwitchArrow onClick={() => setNumValue(numValue - 1)}>
            <Icon name="chevronleft" />
          </DaySwitchArrow>
        )}
      </div>
      <div>
        <strong>
          {numValue === -1 ? t("widget:daySwitch.arrivalPrevDay") : `${t("widget:daySwitch.day")} ${numValue + 1}`}
        </strong>
        <br />
        {format(date, "dd.MM.yyyy")}
      </div>
      <div style={{ minWidth: 44 }}>
        {max !== undefined && numValue < max && (
          <DaySwitchArrow onClick={() => setNumValue(numValue + 1)}>
            <Icon name="chevronright" />
          </DaySwitchArrow>
        )}
      </div>
    </DaySwitchBase>
  );
};

export default DaySwitch;
